module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "demographics-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [_vm._l((_vm.filteredDemographics), function(demo) {
    return _c('div', {
      key: demo.title
    }, [_c('el-card', {
      staticClass: "demo-card",
      class: {
        blacklisted: demo.blacklisted
      },
      attrs: {
        "shadow": "hover"
      }
    }, [(!demo.blacklisted) ? _c('el-popconfirm', {
      attrs: {
        "title": "Are you sure to blacklist this demographic?",
        "icon": "el-icon-info",
        "icon-color": "red",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No"
      },
      on: {
        "onConfirm": function($event) {
          return _vm.blacklistNugget(demo)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      attrs: {
        "slot": "reference",
        "id": "remove-nugget"
      },
      slot: "reference"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Blacklist field",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-close-notification"
    })])], 1)]) : _vm._e(), _vm._v(" "), (demo.blacklisted) ? _c('span', {
      attrs: {
        "id": "blacklisted-nugget"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "This field is blacklisted",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-star-on"
    })])], 1) : _vm._e(), _vm._v(" "), _c('el-popconfirm', {
      attrs: {
        "title": "Are you sure to permanently delete this?",
        "icon": "el-icon-info",
        "icon-color": "red",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No"
      },
      on: {
        "onConfirm": function($event) {
          return _vm.removeNugget(demo)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Remove from profile",
        "placement": "right-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-minus"
    })])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))]), _vm._v(" "), (demo.field === 'birth_date') ? _c('div', [_c('span', {
      staticClass: "demo-value"
    }, [_vm._v(_vm._s(demo.label.split(" ")[0]))])]) : _c('div', [_c('span', {
      staticClass: "demo-value"
    }, [_vm._v(_vm._s(demo.label))])])], 1)], 1)
  }), _vm._v(" "), (_vm.blacklistedDemographics.length) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "blacklist-toggle"
    },
    on: {
      "click": _vm.toggleBlacklist
    }
  }, [(!_vm.showBlacklisted) ? _c('span', [_vm._v("Show")]) : _c('span', [_vm._v("Hide")]), _vm._v(" Blacklisted Demographics\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1e5f7e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/tabs/DemographicsTab.vue
// module id = 3399
// module chunks = 3